import { motion } from 'framer-motion';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTypewriter } from 'react-simple-typewriter';
import '../../Styles/Home/HomePage.css';
import HomeBackgroundEffect from '../Animation/HomeBackgroundEffect';

const HomePage = () => {

    let [knowMoreState, setKnowMoreState] = useState(false)

    const history = useHistory();

    const greetingText = useTypewriter({
        words: ["Hello", "नमस्ते", "ನಮಸ್ಕಾರ", "నమస్కారం"],
        loop: false,
        typeSpeed: 80
    })

    return (
        <motion.div initial={{ scaleX: 0, opacity: 0 }} animate={{ scaleX: 1, opacity: 1 }} exit={{ scaleX: 0, opacity: 0 }} transition={{ duration: 0.5 }}>
            <div className="homepage-main-container flex-box">
                <HomeBackgroundEffect />
                <div className="profile-pic-cover">
                    <img className="profile-pic" src={process.env.PUBLIC_URL + './Images/profilePicture.jpg'} alt="" />
                </div>
                <div className="name-plate-cover">
                    <h1 className="name-plate">
                        <span>{greetingText} {greetingText !== "Hello" ? <>🙏</> : <>👋</>}</span>
                    </h1>
                    <h1 className="name-plate">
                        <span>
                            My name is
                            <span className="tag-highlight"> Gurunath Sahukar</span>
                        </span>
                    </h1>
                </div>
                <div>
                    <h1 className="name-plate">
                        <span>I'm from Ranebennur, Karnataka</span>
                    </h1>
                </div>
                <button className="home-know-more-button flex-box" onClick={() => history.push(`/about`)} onMouseEnter={() => setKnowMoreState(true)} onMouseLeave={() => setKnowMoreState(false)}>
                    {
                        knowMoreState ? (
                            <span>
                                About Me
                            </span>
                        ) : (
                            <span>
                                Know More
                            </span>
                        )
                    }
                    <span>
                        <i className="fa fa-arrow-right" aria-hidden="true"></i>
                    </span>
                </button>
            </div>
        </motion.div>
    )
}

export default HomePage
